import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import { CommonErrorType, DialogType } from '../../../../common/enums';
import { fetchExternalAuthorizationRequest } from '../../../../common/fetch';
import { t } from '../../../../common/i18n';
import { convertToCommonErrors } from '../../../../common/utils/errorUtils';
import { AuthorizationScene } from '../../../../components/AuthorizationScene/AuthorizationScene.js';
import { openDialog } from '../../dialogStore.js';
import type { Token } from '../../../../common/constants/pathInterfaces.js';
import type { CommonError } from '../../../../common/types/errors';
import type { OwnerChangeRequestState } from '../../../../common/types/states';

const handleError = (status: number): CommonError[] => {
  if (status === 400 || status === 404) {
    return [{ message: t.C8BR('The link has expired or it is invalid.'), type: CommonErrorType.VALIDATION }];
  }
  return convertToCommonErrors(`ajax error ${status}`, status);
};

export const AuthorizeNumberPortingPath = () => {
  const { state: locationState } = useLocation();
  const { token = '' } = useParams<Token>();
  const [state, setState] = useState<OwnerChangeRequestState>({
    authorizationRequestId: token,
    mobileNumber: '',
    newOwnerCompanyName: '',
    loading: true,
    errors: locationState?.errors,
  });

  useEffect(() => {
    const fn = async () => {
      if (locationState?.error) {
        openDialog({ type: DialogType.EXTERNAL_AUTHENTICATION_FAIL });
      }

      setState(prev => ({
        ...prev,
        loading: true,
        errors: locationState?.errors,
      }));

      try {
        const response = await fetchExternalAuthorizationRequest(token);
        setState(prev => ({
          ...prev,
          loading: false,
          mobileNumber: response.mnpAuthorizationRequest?.mobileNumber ?? '',
          newOwnerCompanyName: response.mnpAuthorizationRequest?.newOwnerCompanyName ?? '',
        }));
      } catch (error) {
        setState(prev => ({
          ...prev,
          loading: false,
          errors: handleError(error.status),
        }));
      }
    };
    void fn();
  }, [token, locationState]);

  return <AuthorizationScene authorizationRequest={state} />;
};
